export const proslj_isprave_novom= {
    templateId: 73,
    category: 7,
    templateTitle: 'Izjava o zapljeni po pristanku dužnika - prosljeđivanje novom poslodavcu radnika',
    templateDescription: `<p>U slučaju prestanka radnog odnosa radnika za kojega je vjerovnik - ovrhovoditelj dostavio poslodavcu privatnu ispravu s učinkom pravomoćnog rješenju o ovrsi, poslodavac je dužan dostaviti ispravu novom poslodavcu, ukoliko mu je poznat (uz obavijest vjerovniku) ili je ispravu dužan vratiti vjerovniku - ovrhovoditelju (ukoliko mu nije poznat novi poslodavac radnika).</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Dužnik može privatnom ispravom potvrđenom kod javnog bilježnika dati suglasnost da se radi naplate tražbine vjerovnika zaplijeni njegova plaća, odnosno drugo stalno novčano primanje (suglasnost o zapljeni plaće), osim u dijelu u kojem je to primanje izuzeto od ovrhe.</p>
    <p>Isprava se izdaje u jednom primjerku te ima pravni učinak pravomoćnog rješenja o ovrsi. Ispravu s učincima dostave rješenja o ovrsi poslodavcu dostavlja vjerovnik, putem davatelja poštanskih usluga preporučenom poštanskom pošiljkom s povratnicom ili preko javnog bilježnika. Ne dostavi li se na opisani način, dostava ne proizvodi učinke dostave rješenja o ovrsi.</p>
    <p>Poslodavac ovršenika na temelju te isprave dužan je zaplijenjeni dio plaće isplatiti, odnosno isplaćivati ovrhovoditelju po isteku roka od šezdeset dana od dana njezina primitka.</p>
    <p>U slučaju da propustio postupiti po suglasnosti za zapljenu plaće (privatnoj ispravi), ovrhovoditelj bi mogao samo u parničnom postupku potraživati naknadu štete od poslodavca zbog neizvršavanja svojih obveza.</p>
    <p>Ukoliko poslodavac ne može postupiti po dostavljenoj privatnoj ispravi uslijed ranijih obustava čiji iznos bi bio viši od najviše dopuštenog iznosa iz čl. 173. Ovršnog zakona, predlaže se o tome obavijestiti ovrhovoditelja prema primjeru <a class="local-link"  href="/contract?template=70">ovdje</a>.
    <p>Kod prestanka radnog odnosa radnika za kojega je zaprimio privatnu ispravu, poslodavac ima sljedeće obveze:<p>
    <li> ukoliko mu je poznat novi poslodavac - bez odgode, preporučenom pošiljkom s povratnicom privatnu ispravu dostaviti novom poslodavcu prema dolje navedenom primjeru (prijedlog je da se o navedenoj dostavi obavijesti i vjerovnik prema primjeru <a class="local-link" href="/contract?template=73.1">ovdje</a>), </li>
    <li> ukoliko mu nije poznat novi poslodavac - bez odgode, preporučenom pošiljkom s povratnicom  dostaviti privatnu ispravu vjerovniku (ovrhovoditelja) prema primjeru <a class="local-link" href="/contract?template=74">ovdje</a>.</li>
    <br>
    <p>Primjerak dolje navedene obavijesti se odnosi na situaciju u kojoj se privatna isprava dostavlja novom poslodavcu.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Povrat osnove za plaćanje radniku (dužniku) ili slanje osnove za plaćanje krivom adresatu/primatelju</strong></p>
    <p>Pojašnjenje: budući da se neke osnove za plaćanje izdaju samo u jednom primjerku (isprava po pristanku dužnika) i da postoji rizik od nepostupanja po ispravi zbog greške poslodavca (neodašiljanje isprave na vrijeme i sl.), postoji opasnost za poslodavca da će odgovarati za štetu vjerovniku ukoliko ispravu preda trećemu (radniku ili bilo kojoj drugoj osobi) ili ne postupi kako je zakonom određeno. Iz navedenih razloga, uvijek je potrebno postupiti na način određen Ovršnim zakonom te predati isprave novom poslodavcu ako mu je poznat ili vratiti vjerovniku preporučenom pošiljkom s povratnicom.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Ovršni zakon.</p>
  `,
  sides: [
    {
      prefix: "",
      signature: "",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Naziv primatelja",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
      {
        type: "input",
        required: false,
        placeholder: "Ostali podaci po potrebi",
      },
    ],
      suffix: "",
    }
  ],

  headline: "",
    title: '\r\n\r\nPREDMET: Dostava privatne isprave s učinkom pravomoćnog rješenja o ovrsi na postupanje',
    noArticleNumbers: true,
    noArticleTitle: true,
    suffix: ' ',

    articles: [
        {
            title: '',
            mandatory: false,
            dummy: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: '- molim na ruke, ________________',
                    help: 'Po želji, slobodno upišite osobu kojoj želite dostaviti dopis.',
                    value: '',
                }],
        },
            
                {
                    title: '',
                    mandatory: true,
                    dummy: true,
                    exampleContent: true,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'Poštovani,\r\n\r\nza našeg prijašnjeg radnika ____________________, iz ________________,  koji je trenutno zaposlen kod Vas, prethodno smo od radnikovog vjerovnika (ovrhovoditelja) zaprimili zahtjev za zapljenom dijela primanja na temelju isprave iz čl. 202. Ovršnog zakona. \r\nIz navedenog razloga, dostavljamo Vam navedenu privatnu ispravu radi daljnjeg postupanja, a o izvršenoj dostavi ćemo obavijestiti i vjerovnika (ovrhovoditelja).\r\n\r\nS poštovanjem.',
                            value: '',
                        }],
                },
                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Dostaviti:\r\n1) Novom poslodavcu radnika \r\n2) Kadrovska služba \r\n\r\n Na znanje:\r\n1) Ovrhovoditelju (vjerovniku) radnika',
                        help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                      }
                    ]
                  },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/73_proslj_isprave_novom.ts